import { useContainer, usePlayer } from "../../player/context.js";
import { useLatestRef } from "../../utils/use-latest-ref.js";
import { DialogContextProvider } from "../dialog/context.js";
import { useDialogRoot } from "../dialog/use-dialog-root.js";
import { ErrorDialogContextProvider } from "./context.js";
import { ErrorDialogCore, ErrorDialogDataAttrs } from "@videojs/core";
import { selectError } from "@videojs/core/dom";
import { useRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/error-dialog/root.tsx
/** Opens from player error state and provides it to the shared dialog parts. */
function ErrorDialogRoot({ children }) {
	const errorState = usePlayer(selectError);
	const container = useContainer();
	const lastError = useRef(errorState?.error ?? null);
	if (errorState?.error) lastError.current = errorState.error;
	const errorStateRef = useLatestRef(errorState);
	const dialogContext = useDialogRoot({
		open: Boolean(errorState?.error),
		onOpenChange(nextOpen) {
			if (!nextOpen) errorStateRef.current?.dismissError();
		},
		coreFactory: createErrorDialogCore,
		stateAttrMap: ErrorDialogDataAttrs,
		idPrefix: "error-dialog",
		interactionRoot: container
	});
	if (!errorState) return null;
	return /* @__PURE__ */ jsx(ErrorDialogContextProvider, {
		value: { lastError: lastError.current },
		children: /* @__PURE__ */ jsx(DialogContextProvider, {
			value: dialogContext,
			children
		})
	});
}
function createErrorDialogCore() {
	return new ErrorDialogCore();
}
//#endregion
export { ErrorDialogRoot };

//# sourceMappingURL=root.js.map